import { render, staticRenderFns } from "./lifeQuestion.vue?vue&type=template&id=53069614&scoped=true"
import script from "./lifeQuestion.vue?vue&type=script&lang=js"
export * from "./lifeQuestion.vue?vue&type=script&lang=js"
import style0 from "./lifeQuestion.vue?vue&type=style&index=0&id=53069614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53069614",
  null
  
)

export default component.exports